import React from 'react';
import HelpContent from './HelpContent';
import SST_residencial from 'img/SST_casas.PNG';

const SolaresResidencialHelp = () => (
  <HelpContent>
    <h1>Sistema Solar Térmico en sector residencial</h1>
    <p>
    Esta medida analiza el impacto de la introducción de Sistemas Solares Térmicos en viviendas para los procesos de calentamiento de agua.
     El programa tiene como objetivo la instalación en residencias existentes, tecnologías que aprovechan la energía solar para calentar agua con el fin de satisfacer 
     las necesidades de ACS en aplicaciones domésticas. Estos sistemas utilizan colectores solares para capturar la radiación solar y transferirla al agua, proporcionando 
     una fuente de energía limpia y renovable. 
    </p>
    <p>
     La siguiente figura muestra un ejemplo de implementación de esta tecnología.
     </p>

     <img src={SST_residencial} alt="SST en sector residencial" />
    <label>Figura: Sistema Solar Térmico. Fuente: SUN Chile</label>
  
    <p>
    <strong>Trayectoria 1:</strong> se implementan 20.000 viviendas por año en el periodo 2025-2050.
    </p>
    <p>
    <strong>Trayectoria 2:</strong> se implementan 20.000 viviendas por año en el periodo 2025-2030 y 50.000 viviendas por año en el periodo 2031-2050.
    </p>
  </HelpContent>
);

export default SolaresResidencialHelp;
